import withComponentName from '../../../../decorators/withComponentName';

import './styles.css';
import MacbookIMG from '../../../../../../assets/images/corporate/fc-macbook.png';
import IpadIphoneIMG from '../../../../../../assets/images/corporate/fc-ipad-iphone.png';
import DevicesIMG from '../../../../../../assets/images/corporate/fc-devices.png';
import AppstoreIMG from '../../../../../../assets/images/corporate/appstore.png';
import GooglePlayIMG from '../../../../../../assets/images/corporate/google-play-icon.png';

const CorporateFinancialContent = () => (
  <div className="FCSection">
    <span className="FCSection__dot-container">
      <span className="FCSection__dot-sub-container">
        <span className="FCSection__dot" />
      </span>
    </span>

    <h1 className="FCSection__head">experience the future of financial content now</h1>
    <h3 className="FCSection__sub-head">try us out</h3>

    <div className="FCSection__content">
      <div className="FCSection__content--item">
        <img src={MacbookIMG} />
        <div className="item__footer">
          <p className="item__footer--text">
            <a href="https://www.cityfalcon.ai">CityFALCON.ai</a>
          </p>
        </div>
      </div>
      <div className="FCSection__content--item">
        <img src={IpadIphoneIMG} />
        <div className="item__footer">
          <div className="item__footer--icon-app-store">
            <a target="_blank" href="https://itunes.apple.com/us/app/cityfalcon-financial-news/id1148560018" rel="noreferrer">
              <img src={AppstoreIMG} />
            </a>
          </div>
          <div className="item__footer--icon-google-play">
            <a target="_blank" href="https://play.google.com/store/apps/details?id=com.cityfalcon" rel="noreferrer">
              <img src={GooglePlayIMG} />
            </a>
          </div>
        </div>
      </div>
      <div className="FCSection__content--item">
        <img src={DevicesIMG} />
        <div className="item__footer">
          <p className="item__footer--text">
            <a href="https://www.amazon.co.uk/dp/B07532KNVM">Amazon Alexa</a>
            <br />
            <a href="https://assistant.google.com/services/a/uid/000000f916b51058">Google Home</a>
          </p>
        </div>
      </div>
    </div>
  </div>
);

export default withComponentName(CorporateFinancialContent);
